import styled from "styled-components";

export const MapWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const HeaderText = styled.h1`
  text-transform: uppercase;
  margin-right: 25px;
`;

export const InfoText = styled.p`
  position: absolute;
  top: 25px;
  right: 25px;
  font-size: 16px;
  font-style: italic;
`;
